import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { MIXPANEL_APP_NAME } from 'constants/mixpanel'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getOperationCode,
  getProductCallPrice,
  getProductPriceValue,
  getProductTitle,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToCatalogEvent = (state) => ({
  'Click Name': 'See on the map',
  'Operation Code': getOperationCode(state),
  'Page Name': 'See on the map',
  'Type': MIXPANEL_APP_NAME
})

const mapStateToProductEvent = (state) => ({
  'Click Name': 'Travel Product See On Map',
  'Lowest Price': getProductCallPrice(state),
  'Operation Code': getOperationCode(state),
  'Product': getProductTitle(state),
  'Product Price': getProductPriceValue(state),
  'Under Universe': getSubUniverseName(state),
  'Universe': getUniverseName(state)
})

const clickShowMapTrackingEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.map.SHOW_MAP),
  tap(action => {
    const eventName = 'Click'
    const variant = action.payload.variant
    const properties = variant === 'product' ? mapStateToProductEvent(state$.value) : mapStateToCatalogEvent(state$.value)

    track(eventName, properties, { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickShowMapTrackingEpic
